import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dimensions } from 'react-native';
import { LANDSCAPE, LANDSCAPE_ENABLED, PORTRAIT } from '../config/Constant';
import { setAppOrientation, setAppHeight, setAppWidth } from '../Redux/Reducers/appConfigReducer';



export const useOrientation = () => {
  const dispatch = useDispatch();

  const getInitialDimensions = () => {
    const { width, height } = Dimensions.get('window');

    if(!LANDSCAPE_ENABLED){
      return { orientation: PORTRAIT, width, height }
    }
    const orientation = width > height ? LANDSCAPE : PORTRAIT;
    return { orientation, width, height };
  };

  const [dimensions, setDimensions] = useState(getInitialDimensions);

  useEffect(() => {

    setTimeout(() => {
      dispatch(setAppOrientation(dimensions.orientation));
      dispatch(setAppWidth(dimensions.width));
      dispatch(setAppHeight(dimensions.height));
    }, 500);

    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      const { width, height } = window;
      // const newOrientation = width > height ? LANDSCAPE : PORTRAIT;
      let newOrientation = PORTRAIT;
      if(LANDSCAPE_ENABLED){
        newOrientation = width > 450 ? LANDSCAPE : PORTRAIT;
      }

      // Only update if dimensions or orientation actually changed
      setDimensions(prev => {
        if (prev.orientation !== newOrientation || prev.width !== width || prev.height !== height) {
          // Update Redux store
          dispatch(setAppOrientation(newOrientation));
          dispatch(setAppWidth(width));
          dispatch(setAppHeight(height));

          return { orientation: newOrientation, width, height };
        }
        return prev;
      });
    });

    return () => {
      subscription?.remove();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return dimensions;
};

export const isLandscape = (orientation) => orientation === LANDSCAPE && LANDSCAPE_ENABLED;
export const isPortrait = (orientation) => orientation === PORTRAIT;
